export default ['osc-product-list', 'osc-product-carousel', 'isc-product-list']
